// extracted by mini-css-extract-plugin
export var locationCard = "_oh-0";